import { useState, useEffect } from 'react';
import { assetsAPI } from '../services/api';

/**
 * useAssets — fetches all assets for use in dropdowns.
 * Returns { assets, loading } where assets is a flat list.
 */
export function useAssets() {
  const [assets, setAssets]   = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    assetsAPI.list({ limit: 200 })
      .then(({ data }) => setAssets(data.data.items || data.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return { assets, loading };
}
